module.exports = __webpack_public_path__ + "media/images/zj11-c1-3816d3ee13dcc1a53b4e458726b56ce4.png";